import {RootState} from "../store";
import {createSelector} from '@reduxjs/toolkit'

export const selectTranslatedString = createSelector(
    (state: RootState) => state.app.translatedStrings,
    translatedStrings => translatedStrings
);

export const selectDirection = createSelector(
    (state: RootState) => state.app.direction,
    direction => direction
);

export const selectIsLoading = createSelector(
    (state: RootState) => state.app.isLoading,
    isLoading => isLoading
);

export const selectCurrentLang = createSelector(
    (state: RootState) => state.app.lang,
    lang => lang
);

export const selectIsFormDirty = createSelector(
    (state: RootState) => state.app.isFormDirty,
    isFormDirty => isFormDirty
);

export const selectFindCampaignStep = createSelector(
    (state: RootState) => state.app.findCampaignStep,
    findCampaignStep => findCampaignStep
);

export const selectDeliveryServiceStep = createSelector(
    (state: RootState) => state.app.deliveryServiceStep,
    deliveryServiceStep => deliveryServiceStep
);

export const selectIsDeliveryServicePaymentAvailable = createSelector(
    (state: RootState) => state.app.isDeliveryServicePaymentAvailable,
    isDeliveryServicePaymentAvailable => isDeliveryServicePaymentAvailable
);

export const selectHouseNumber = createSelector(
    (state: RootState) => state.app.houseNumber,
    houseNumber => houseNumber
);
export const selectIsGAInitialized = createSelector(
    (state: RootState) => state.app.isGAInitialized,
    isGAInitialized => isGAInitialized
);

export const selectShareToken = createSelector(
    (state: RootState) => state.app.shareToken,
    shareToken => shareToken
)

export const selectUserMailSharedProject = createSelector(
    (state: RootState) => state.app.UserMailSharedProject,
    UserMailSharedProject => UserMailSharedProject
)

export const selectRegistrationInvite = createSelector(
    (state: RootState) => state.app.registrationInvite,
    registrationInvite => registrationInvite
)